export default __webpack_public_path__ + "static/media/chev-right-blue-btn.194a11a8.svg";